import { _t } from '../../services/TranslationService.js';
var timelineAgent;

const getType = (item) => {
  if (localStorage.getItem('lang') === 'de') {
    return `${item.value}. ${_t(item.type)}`;
  }
  if (item.value === '1') {
    return `${item.value}st ${_t(item.type)}`;
  } else if (item.value === '2') {
    return `${item.value}nd ${_t(item.type)}`;
  } else {
    return `${item.value}th ${_t(item.type)}`;
  }
}

const getTypeWithIcon = (item, side) => {
  const icon = `<span class="SoccerSummaryRow_Icon ${item.type.replaceAll(' ', '-')}"></span>`
  if (side === 'left') {
    return getType(item) + ' ' + icon;
  }
  return icon + ' ' + getType(item);
}

let Timeline = {
  render: async (game_api_id, live) => {
    if(!game_api_id) {
      return '';
    }
    let view =  /*html*/`<div class="timeline ${live ? 'live' : ''}" game-api-id="${game_api_id}"></div>`
    return view
  },
  after_render: async (game_api_id) => {
    refreshTimeline(game_api_id);

    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
    timelineAgent = setInterval(() => {
      var $view = $('#timeline-view');
      if(!$view) {
        clearInterval(timelineAgent);
        return;
      }

      Timeline.refreshTimeline();
    }, 3000);
  },
  on_unload: () => {
    if(timelineAgent) {
      clearInterval(timelineAgent);
    }
  },
  getTimelineForGame(game_api_id) {
    return new Promise((resolve, reject) => {
      $.getJSON(`${window.location.origin}/games-timeline/${game_api_id}.json`, function( items ) {
        if(!items || !Array.isArray(items)) {
          reject(_t('No data available'));
          return;
        }
    
        let view = '';

        items.reverse().forEach(item => {
          if(item.team !== '0') {
            view += `
            <div class="timeline-row">
              <div>${item.team == '1' ? (getTypeWithIcon(item, 'left'))  : ''}</div>
              <div>${item.minute.split(':')[0]}'</div>
              <div>${item.team == '2' ? (getTypeWithIcon(item, 'right')) : ''}</div>
            </div>`;
          } else {
            view += `<div class="timeline-row-full">${_t(item.type)} ${item.minute}</div>`;
          }
        });
        
        resolve(view);
      }, function() {
        reject(_t('No data available'));
      }).fail(function() {
        resolve(`<div style="text-align: center; color: #ffffff">${_t('No data available')}<div>`);
      });
    });
  },
  refreshTimeline(id) {
    refreshTimeline(id);
  }
}

function refreshTimeline(id) {
  var $view = $(id ? `.timeline[game-api-id=${id}]` : '.timeline.live')
  if(!$view) {
    return;
  }

  $view.each(async function(index) {
    var game_api_id = $(this).attr('game-api-id');
    var content = await Timeline.getTimelineForGame(game_api_id);
    $(this).html(content);
  });
}

export default Timeline;
